__webpack_require__.p = "/bertie-the-brain-homage/";